import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WallOfFame from "./WallOfFame";
import WTFManagement from "./WTFManagement";
import StudentSubmission from "./StudentSubmission";
import { useUserRole } from "../../hooks/useUserRole";
import "./WtfDashboard.css";

const WtfDashboard = () => {
  const { isAdmin, isStudent } = useUserRole();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState("wall"); // wall, submit, management

  // Debug removed - role detection working

  // Check URL params to see which view to show
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const viewParam = urlParams.get("view");

    // Admins open on the WTF Management Dashboard; ?view=wall shows the Wall of Fame board.
    if (isAdmin && viewParam !== "wall") {
      setActiveView("management");
    } else if (viewParam === "submit" && isStudent) {
      setActiveView("submit");
    } else {
      setActiveView("wall");
    }
  }, [location.search, isAdmin, isStudent]);

  const handleViewChange = (view) => {
    setActiveView(view);
    if (view === "management" && isAdmin) {
      navigate("/wtf");
    } else if (view === "submit" && isStudent) {
      navigate("/wtf?view=submit");
    } else if (isAdmin) {
      navigate("/wtf?view=wall");
    } else {
      navigate("/wtf");
    }
  };

  // Render the appropriate component based on active view
  if (activeView === "management" && isAdmin) {
    return (
      <div className="wtf-management wtf-management--with-menu min-h-screen">
        <WTFManagement onToggleView={() => handleViewChange("wall")} />
      </div>
    );
  }

  if (activeView === "submit" && isStudent) {
    return (
      <div className="wtf-submit min-h-screen">
        <StudentSubmission />
      </div>
    );
  }

  // Admins see the shared top menu above the board, so it sits below that
  // menu and grows with its content (autoHeight) instead of filling 100vh.
  // Their close (X) button returns to the WTF Management Dashboard; other
  // roles keep its default (/dashboard).
  return (
    <div
      className={`wtf-dashboard ${
        isAdmin ? "wtf-dashboard--with-menu" : ""
      } min-h-screen w-full`}
    >
      <WallOfFame
        autoHeight={isAdmin}
        onToggleView={isAdmin ? () => handleViewChange("management") : null}
        onClose={isAdmin ? () => handleViewChange("management") : undefined}
      />
    </div>
  );
};

export default WtfDashboard;
